import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import ArticleCard from "@/components/ArticleCard";
import SEO from "@/components/SEO";

export default function GuidesPage() {
  const [articles, setArticles] = useState([]);
  useEffect(() => { api.get("/articles").then(({ data }) => setArticles(data)); }, []);

  const featured = articles.find((a) => a.featured) ?? articles[0];
  const rest = articles.filter((a) => a !== featured);

  return (
    <div>
      <SEO title="Guides & editorial" description="Brand ladders, neighborhood breakdowns, and honest hotel comparisons — written by real US travelers." />
      <section className="bg-cream border-b border-charcoal/5">
        <div className="container-x py-14 md:py-20">
          <div className="overline text-terracotta">Guides · Editorial · Comparisons</div>
          <h1 className="mt-3 font-serif text-5xl md:text-6xl tracking-tight leading-[1.02] max-w-4xl">
            Hotels, decoded. Brands, ranked. Cities, mapped.
          </h1>
        </div>
      </section>

      <section className="container-x py-14 space-y-10">
        {featured && <ArticleCard article={featured} variant="wide" />}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {rest.map((a) => <ArticleCard key={a.id} article={a} />)}
        </div>
      </section>
    </div>
  );
}
